var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var Heading1Icon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M4.268 9.736L2.056 9.4V8H9.672V9.4L7.264 9.736V17.268H17.12V9.736L14.852 9.4V8H22.356V9.4L20.144 9.736V27.152L22.356 27.432V28.804H14.824V27.432L17.12 27.152V19.004H7.264V27.152L9.7 27.432V28.804H2V27.432L4.268 27.152V9.736Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M28.3 15.9039C27.95 16.0372 27.4 16.1956 26.65 16.3789C25.9 16.5622 25.2916 16.6872 24.825 16.7539L24.575 15.3539C25.425 15.1706 26.2916 14.8622 27.175 14.4289C28.075 13.9956 28.825 13.5206 29.425 13.0039H29.45L30.975 13.2539V27.3539L34.075 27.5789V28.8039H25.075V27.5789L28.3 27.3539V15.9039Z",
    fill: "black"
  }));
};
export var Heading1IconGlyph = function (props) {
  return React.createElement(Heading1Icon, __assign({}, props, {
    variant: 'glyph'
  }));
};